/**
 * Deterministic soft colours for category/type pills (Mark, 2026-08-07):
 * the same category always renders the same colour, with no configuration —
 * a stable hash into a small brand-adjacent palette that stays readable.
 */

const PALETTE: Array<{ background: string; color: string }> = [
  { background: '#e3f1f8', color: '#006699' },   // Wave9 blue tint
  { background: '#e9f7ef', color: '#1d7a4f' },   // green
  { background: '#f6eefb', color: '#7a3fa8' },   // purple
  { background: '#fdf2e3', color: '#a86a12' },   // amber
  { background: '#fdeef0', color: '#b0384f' },   // rose
  { background: '#eef0fd', color: '#3f4fb0' },   // indigo
  { background: '#eefaf9', color: '#1d7a76' },   // teal
]

export function pillStyleFor(name: string | null | undefined): { background: string; color: string } {
  const s = (name ?? '').trim().toLowerCase()
  if (!s) return { background: '#eef1f4', color: '#666666' }
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0
  return PALETTE[h % PALETTE.length]
}
